import { useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import { useCaptchaVerification } from './use-captcha-verification.hook'
import { useSnackbar } from 'notistack'

export const useVerification = () => {
  const captchaRef = useRef<ReCAPTCHA>(null)
  const { mutateAsync: verifyCaptcha, data: verificationResp } = useCaptchaVerification()

  const { enqueueSnackbar } = useSnackbar()

  const verifyAsync = async () => {
    if (!captchaRef.current) return false

    try {
      const token = await captchaRef.current.executeAsync()
      if (!token) {
        captchaRef.current?.reset()
        enqueueSnackbar('Verification failed. Please try again', { variant: 'error' })
        return false
      }
      const isSuccess = await verifyCaptcha(token)
      if (!isSuccess) {
        captchaRef.current?.reset()
      }
      return Boolean(isSuccess)
    } catch (error) {
      captchaRef.current?.reset()

      return false
    }
  }

  return {
    verificationResp,
    captchaRef,
    verifyAsync,
  }
}
